module.exports = __webpack_public_path__ + "assets/img/credits.fc1a8998.svg";